// apps/hyperseguros-web/src/components/GoogleAnalytics/isSiblingSubdomain.ts

/**
 * True when `linkHost` is a subdomain of the page's two-label root domain
 * (www.hyper.mx -> portal.hyper.mx). False for the same host, the bare root,
 * other domains and single-label hosts such as localhost.
 */
export function isSiblingSubdomain(
  linkHost: string,
  pageHost: string
): boolean {
  const link = linkHost.toLowerCase()
  const page = pageHost.toLowerCase()
  if (!link || !page || link === page) return false
  const pageLabels = page.split('.')
  if (pageLabels.length < 2) return false
  const root = pageLabels.slice(-2).join('.')
  return link.endsWith(`.${root}`)
}
